
import {
  BarcodeOutlined,
  CheckCircleOutlined,
  EditOutlined,
  EyeOutlined,
  ImportOutlined,
  FilePdfOutlined,
  ExportOutlined,
  CheckSquareTwoTone,
  CloseSquareTwoTone,
  StopOutlined,
  TableOutlined,
  SettingOutlined,
  TagOutlined,
} from "@ant-design/icons";
import { PageHeader,Popconfirm, message, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, dineroDisabledMask, SegmentedItem, TableItemDinamico, FiltroCategoriasInsumosItem } from "../../../Components/Items";
import HeaderActions from "../../../Components/HeaderActions";
import IconArrowsShuffle from "../../../Icons/IconArrowsShuffle";
import CambiarFamilia from "./CambiarFamilia/CambiarFamilia";
import ModalCodigoDeBarras from "./ModalCodigoDeBarras/ModalCodigoDeBarras";
import ModalEtiquetaLoteInsumo from "./ModalEtiquetaLoteInsumo/ModalEtiquetaLoteInsumo";
import ModalVerFormas from "./ModalVerFormas/ModalVerFormas";
import * as XLSX from 'xlsx'

import moment from "moment";
  import "moment/locale/es";
  moment.locale("es");
class Insumos extends Component {
  tableRef = null;
  state = {
    idEditarInsumo: null,
    modalAgregarFamilia: false,
    todasInsumos: [],
    loading: false,
    valor: 3,
    totalRecords: 0,
    idCambiarFamilia: null,
    modalImprimirCodigoDeBarras: false,
    modalImprimirCodigoDeBarrasId: null,
    modalVerFormas: false,
    modalVerFormasId: null,
    textoFiltro: "",
    filtrosCategorias: [],
    insumoEnvioId: null,
  };

  filtrosCategoriasKey = () => `insumosFiltrosCategorias_${this.props.empresaId}`;

  componentDidMount() {
    axios
      .post(
        "configuracionTiendaOnline/obtenerConfiguracionVentaOnline",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2 && res.data.data?.insumoEnvioId) {
          this.setState({ insumoEnvioId: res.data.data.insumoEnvioId.toString() });
        }
      })
      .catch(() => {});

    try {
      const guardado = localStorage.getItem(this.filtrosCategoriasKey());
      if (guardado) {
        const parsed = JSON.parse(guardado);
        if (parsed && Array.isArray(parsed.filtros) && parsed.expira > Date.now()) {
          this.setState({ filtrosCategorias: parsed.filtros });
        } else {
          localStorage.removeItem(this.filtrosCategoriasKey());
        }
      }
    } catch (err) {
      console.warn("No se pudo leer filtrosCategorias persistidos:", err);
    }
  }

  guardarFiltrosCategorias = (filtros) => {
    try {
      if (filtros && filtros.length > 0) {
        localStorage.setItem(
          this.filtrosCategoriasKey(),
          JSON.stringify({ filtros, expira: Date.now() + 10 * 60 * 1000 })
        );
      } else {
        localStorage.removeItem(this.filtrosCategoriasKey());
      }
    } catch (err) {
      console.warn("No se pudo guardar filtrosCategorias:", err);
    }
  };

  onFiltrosCategoriasChange = (nuevos) => {
    this.setState({ filtrosCategorias: nuevos }, () => {
      this.guardarFiltrosCategorias(nuevos);
      if (this.tableRef) {
        this.tableRef.updateExternalFilters({
          valor: this.state.valor,
          textoFiltro: this.state.textoFiltro,
          filtrosCategorias: nuevos.map((f) => f.valorId),
        });
      }
    });
  };
  consultarInsumos(params) {
    this.setState({ loading: true })
    axios
      .post(
        "insumos/selectTodosInsumos",
        { empresaId: this.props.empresaId, ...params },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todasInsumos: res.data.data.map((data) => {
              let compraVenta
              if (data.compra && data.venta) {
                compraVenta = ['Compra', 'Venta'];
              } else if (data.compra) {
                compraVenta = 'Compra'
              } else if (data.venta) {
                compraVenta = 'Venta'
              } else {
                compraVenta = 'Ninguno'
              }
              return {
                ...data,
                compraVenta
              }
            }),
            totalRecords: res.data.totalRecords || 0,
            loading: false
          });
        } else {
          this.setState({ todasInsumos: [], loading: false });
        }
      });
  }
  deshabilitarInsumo(value) {
    if (this.state.insumoEnvioId && value.toString() === this.state.insumoEnvioId) {
      message.error("Este insumo está configurado como el insumo de envío del ecommerce y no puede deshabilitarse.");
      return;
    }
    axios
      .post(
        "insumos/deshabilitarInsumo",
        { insumoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Insumo deshabilitado");
        } else {
          message.error("Sucedio un eror y no se pudo deshabilitar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }
  habilitarInsumo(value) {
    axios
      .post(
        "insumos/habilitarInsumo",
        { insumoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Insumo habilitado");
        } else {
          message.error("Sucedio un eror y no se pudo habilitar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }
  imprimirCodigoDeBarras(value) {
    this.setState({ modalImprimirCodigoDeBarras: true, modalImprimirCodigoDeBarrasId: value });
  }
  abrirEtiquetaLoteInsumo(value) {
    this.setState({ modalEtiquetaLoteInsumo: true, modalEtiquetaLoteInsumoId: value });
  }
  agregarInsumo() {
    this.props.history.push("/panel/agregarInsumo");
  }
  editarInsumo(id) {
    this.props.history.push("/panel/editarInsumo", { id });
  }
  abrirAgregarFamilia() {
    this.setState({ modalAgregarFamilia: true });
  }
  cerrarAgregarFamilia() {
    this.setState({ modalAgregarFamilia: false });
    this.consultarInsumos();
  }

  importarInsumos() {
    this.props.history.push('/panel/importarInsumos')
  }

  subirImagenesInsumos() {
    this.props.history.push('/panel/subirImagenesInsumos')
  }

  subirFichasTecnicasInsumos() {
    this.props.history.push('/panel/subirFichasTecnicasInsumos')
  }

  edicionMasivaInsumos() {
    this.props.history.push('/panel/edicionMasivaInsumos')
  }

  edicionMasivaEquivalencias() {
    this.props.history.push('/panel/edicionMasivaEquivalencias')
  }

  exportarInsumos(){
    this.setState({loading:true}); 

    axios
    .post(
      "insumos/exportarInsumos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
    )
    .then((res) => {
      this.setState({loading: false})
      if(res.data.success === 2){
        const insumos = res.data.insumos;
        const preciosEmpresa = res.data.preciosEmpresa;

        const cabecerasPrecios = {};
        preciosEmpresa.forEach(precio => {
            cabecerasPrecios['precio_' + precio._id] = `Precio ${precio.nombre}`;
        });


        const datosInsumos = insumos.map(insumo => {
            
            const filaExcel = {
              "Código" : insumo.codigo,
              "Clave": insumo.clave,
              "Código Proveedor": insumo.codigoProveedor, 
              "Código de Barras": insumo.codigoBarras, 
              "Descripción": insumo.descripcion,
              "Descripción Larga": insumo.descripcionLarga,
              "Familia": insumo.familia?.descripcion || "",
              "Marca" : insumo.marca?.nombre || "Sin marca",
              "Unidad" : insumo.unidad?.nombre || "", 
              "Compra" : insumo.compra ? "Permitida" : "No permitida",
              "Venta" : insumo.venta ? "Permitida" : "No permitida", 
              "Inventariable" : insumo.inventariable ? "Si" : "No", 
              "Costo" : insumo.costo, 
              "Grupo Sat" : insumo.grupoSat ? `${insumo.grupoSat.codigo} - ${insumo.grupoSat.descripcion}` : "", 
              "Clase Sat" : insumo.claseSat ? `${insumo.claseSat.codigo} - ${insumo.claseSat.descripcion}` : "", 
              "Fecha de Alta" :  moment(insumo.createdAt).format("DD/MM/YYYY"),
            };

            for (const keyPrecio in cabecerasPrecios) {
                filaExcel[cabecerasPrecios[keyPrecio]] = insumo[keyPrecio]; 
            }

            return filaExcel;
        });

        // Crear la hoja de Excel
          const ws = XLSX.utils.json_to_sheet(datosInsumos);

          // Aplicar estilos al encabezado
          const encabezados = Object.keys(datosInsumos[0]);

          ws["!cols"] = encabezados.map(() => ({ wch: 20 })); // Ajustar ancho de columnas

          // Crear el libro de Excel
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Insumos");

          // Exportar archivo Excel
          XLSX.writeFile(wb, "insumos.xlsx");
      }
    })
    .catch((error) => {
      console.log(error);
      this.setState({ loading: false });
      message.error("Ocurrió un error al generar el archivo");
    });
  }

  cambiarFamilia(id) {
    this.setState({ idCambiarFamilia: id });
  }

  cerrarCambiarFamilia() {
    this.setState({ idCambiarFamilia: null });
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
  }

  cerrarModalCodigoDeBarras() {
    this.setState({ modalImprimirCodigoDeBarras: false, modalImprimirCodigoDeBarrasId: null });
  }

  cerrarEtiquetaLoteInsumo() {
    this.setState({ modalEtiquetaLoteInsumo: false, modalEtiquetaLoteInsumoId: null });
  }

  abrirVerFormas(id) {
    this.setState({ modalVerFormas: true, modalVerFormasId: id });
  }

  cerrarModalVerFormas() {
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
    this.setState({ modalVerFormas: false, modalVerFormasId: null });
  }


  render() {
    const segmentedOptions = [
      { label: 'Venta', value: 1 },
      { label: 'Compra', value: 2 },
      { label: 'Ambos', value: 3 },
      { label: 'Ninguno', value: 4 },
      { label: 'Todos', value: 5 },
      { label: 'Deshabilitados', value: 6 },
    ].filter(opt => {
      if (opt.value === 1 && this.props.noMostrarInsumoVenta) return false;
      if (opt.value === 2 && this.props.noMostrarInsumoCompra) return false;
      if (opt.value === 3 && this.props.noMostrarInsumoAmbos) return false;
      if (opt.value === 4 && this.props.noMostrarInsumoNinguno) return false;
      if (opt.value === 5 && this.props.noMostrarFiltroTodos) return false;
      if (opt.value === 6 && this.props.noMostrarDeshabilitados) return false;
      return true;
    });
    const valorDefault = segmentedOptions.find(o => o.value === 3) ? 3 : (segmentedOptions[0]?.value || 3);
    const valorActual = segmentedOptions.find(o => o.value === this.state.valor) ? this.state.valor : valorDefault;
    const columns = [
      {
          title: "C / V",
          dataIndex: "compraVenta",
          key: "compraVenta",
          width: "8%",
          render: (value) => (
          <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {(Array.isArray(value) ? value : [value]).map((v, i) => {
              let style = {
                display: "inline-block",
                padding: "1px 7px",
                borderRadius: 8,
                fontSize: 11,
                lineHeight: "15px",
                minWidth: 0,
                maxWidth: 100,
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                border: "1px solid #e0e0e0",
                marginBottom: 2,
              };
             if (v === "Compra") {
                style.background = "linear-gradient(135deg, rgba(132, 204, 22, 0.30) 0%, rgba(132, 204, 22, 0.10) 100%)";
                style.color = "#35471d";
                style.border = "1px solid rgba(132, 204, 22, 0.50)";
                style.boxShadow = "0 1px 3px rgba(132, 204, 22, 0.18)";
              } else if (v === "Venta") {
                style.background = "linear-gradient(135deg, rgba(6, 182, 212, 0.30) 0%, rgba(6, 182, 212, 0.10) 100%)";
                style.color = "#0a4555";
                style.border = "1px solid rgba(6, 182, 212, 0.50)";
                style.boxShadow = "0 1px 3px rgba(6, 182, 212, 0.18)";
              } else if (v === "Ninguno") {
                style.background = "linear-gradient(135deg, #fafafa 0%, #f0f0f0 100%)";
                style.color = "#4d515b";
                style.border = "1px solid #e5e7eb";
                style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.03)";
              }
              return (
                <span key={i} style={style} title={v}>
                  {v}
                </span>
              );
            })}
          </div>
        ),
      },
      {
        title: <span style={{ whiteSpace: "normal", wordBreak: "break-word", display: "block", lineHeight: 1.3 }}>Código / Fecha Alta</span>,
        dataIndex: "codigo",
        key: "codigo",
        render: (value, record) => (
          <div>
            <div>{value}</div>
            {record.createdAt && (
              <div style={{ color: "#6a6a6a", fontSize: "11px" }}>{moment(record.createdAt).format("DD/MM/YYYY")}</div>
            )}
          </div>
        ),
        defaultSortOrder: 'ascend',
        sorter: (a, b) => {
          if (a.codigo < b.codigo) {
            return -1;
          }
          if (a.codigo > b.codigo) {
            return 1;
          }
          return 0;
        },
        buscar: "codigo",
        width: "8%",
      },
      {
        title: <span style={{ whiteSpace: "normal", wordBreak: "break-word", display: "block", lineHeight: 1.3 }}>Clave / Código de Barras</span>,
        key: "claveCodigoBarras",
        sorter: true,
        buscar: "clave", //checar amba búsqueda
        width: "13%",
        render: (record) => (
          <div>
            <div style={{fontWeight: 400 , color: "#6a6a6a" }}>{record.clave}</div>
            <div style={{color: "#000000", fontSize: "12px",fontWeight:500 }}>{record.codigoBarras}</div>
          </div>
        ),
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: true,
        buscar: "descripcion",
        width: "20%",
        ellipsis: false,
        render: (value) => (
          <Tooltip title={value} placement="topLeft" mouseEnterDelay={3}>
            <div
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: 1.4,
                minHeight: "2.8em",
              }}
            >
              {value}
            </div>
          </Tooltip>
        ),
      },
      {
        title: "Inventariable",
        dataIndex: "inventariable",
        key: "inventariable",
        render: (value) => 
        value ? 
            <CheckSquareTwoTone twoToneColor={["#0374fe", "#edf9ff"]} style={{ fontSize: 20 }} /> 
            : 
            <CloseSquareTwoTone twoToneColor={["#bdbdbd", "#f9f9f9"]} style={{ fontSize: 20 }} />,
            align: 'center',
            width: "7%",
          },
      
      {
        title: "U. Costo",
        dataIndex: "costo",
        key: "costo",
        sorter: true,
        render: (value, record) => (
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: "12px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(value, this.props.decimalesEmpresa)}</span>
              <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda || "MXN"}</span>
            </div>
          </div>
        ),
        width: "12%",
      },
      {
        title: "Unidad",
        dataIndex: "unidad",
        key: "unidad",
        buscar: "unidad",
        width: "10%",
        align: 'center',
      },
      {
        key: "tipoDeInsumo",
        title: <span style={{ whiteSpace: "normal", wordBreak: "break-word", display: "block", lineHeight: 1.3 }}>Tipo de Insumo / Familia</span>,
        render: (record) => (
          <div>
            <div style={{ fontWeight: 400 , color: "#6a6a6a"}}>{record.tipoDeInsumo}</div>
            <div style={{ color: "#000000", fontSize: "12px",fontWeight:500 }}>{record.familia}</div>
          </div>
        ),
        width: "13%",
        buscar: "tipoDeInsumo",
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "14%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, index) => {
          let buttons = [];

          // Botón Código de Barras
          buttons.push(
            <Tooltip title="Código de Barras" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`barcode-${index}`}
                type="default"
                size="small"
                blanco
                icon={<BarcodeOutlined />}
                onClick={() => this.imprimirCodigoDeBarras(value._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          // Botón Etiqueta (misma etiqueta que se imprime en Lotes, para cualquier insumo)
          buttons.push(
            <Tooltip title="Etiqueta" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`etiqueta-${index}`}
                type="default"
                size="small"
                morado
                icon={<TagOutlined />}
                onClick={() => this.abrirEtiquetaLoteInsumo(value._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          if (this.props.permisoEditarInsumo) {
            buttons.push(
              <Tooltip title="Editar Insumo" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`editar-${index}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.editarInsumo(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          // Botón Ver Formas (Taxidermia)
          if (this.props.taxidermia) {
            buttons.push(
              <Tooltip title="Ver Formas" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`formas-${index}`}
                  type="default"
                  size="small"
                  azul
                  icon={<EyeOutlined />}
                  onClick={() => this.abrirVerFormas(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          if (value.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${index}`}
                title="Seguro que quieres deshabilitar este insumo"
                onConfirm={() => this.deshabilitarInsumo(value._id)}
                okText="Si"
                cancelText="No"
              >
                <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm
                key={`habilitar-${index}`}
                title="Seguro que quieres habilitar este insumo"
                onConfirm={() => this.habilitarInsumo(value._id)}
                okText="Si"
                cancelText="No"
              >
                <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          }

          if (this.props.permisoEditarInsumo) {
            buttons.push(
              <Tooltip title="Cambiar Familia" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`familia-${index}`}
                  type="default"
                  size="small"
                  rosa
                  icon={<span style={{ fontSize: '16px', display: 'flex', alignItems: 'center' }}><IconArrowsShuffle size={16} stroke={2.5} /></span>}
                  onClick={() => this.cambiarFamilia(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title="Insumos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
           
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={segmentedOptions}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({
                        valor: value,
                        textoFiltro: this.state.textoFiltro,
                        filtrosCategorias: this.state.filtrosCategorias.map((f) => f.valorId),
                      });
                    }
                    this.setState({ valor: value })
                  }}
                  value={valorActual}
                />
              )}
              {this.props.filtrosAvanzadosInsumos && (
                <FiltroCategoriasInsumosItem
                  filtros={this.state.filtrosCategorias}
                  onChange={this.onFiltrosCategoriasChange}
                  empresaId={this.props.empresaId}
                  headersToken={this.props.headersToken}
                  buttonStyle={{ height: 32, padding: '0 12px' }}
                />
              )}
              {this.props.filtrosAvanzadosInsumos && this.props.permisoAccesoFiltrosAvanzados && (
                <Tooltip title="Configurar categorías" placement="top">
                  <ButtonItem
                    type="primary"
                    gris
                    onClick={() => this.props.history.push("/panel/configuracionCategoriasInsumos")}
                    style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
                    icon = {<SettingOutlined style={{ fontSize: '16px' }} />}
                  />
                </Tooltip>
              )}
             <HeaderActions>
                {this.props.permisoImportarInsumo && (
                  <ButtonItem
                    type="default"
                    icon={<ImportOutlined />}
                    onClick={() => this.importarInsumos()}
                  >
                    Importar Insumos
                  </ButtonItem>
                )}
                {this.props.permisoImportarInsumo && (
                  <ButtonItem
                    type="default"
                    icon={<ImportOutlined />}
                    naranja
                    onClick={() => this.subirImagenesInsumos()}
                  >
                    Subir Imágenes ZIP
                  </ButtonItem>
                )}
                {this.props.permisoImportarInsumo && (
                  <ButtonItem
                    type="default"
                    icon={<FilePdfOutlined />}
                    morado
                    onClick={() => this.subirFichasTecnicasInsumos()}
                  >
                    Subir Fichas Técnicas ZIP
                  </ButtonItem>
                )}
                {this.props.permisoImportarInsumo && (
                  <ButtonItem
                    type="default"
                    icon={<TableOutlined />}
                    onClick={() => this.edicionMasivaInsumos()}
                    verde
                  >
                    Edición Masiva
                  </ButtonItem>
                )}
                {this.props.permisoImportarEquivalencias && (
                  <ButtonItem
                    type="default"
                    icon={<TableOutlined />}
                    onClick={() => this.edicionMasivaEquivalencias()}
                    azul
                  >
                    Edición Masiva de Equivalencias
                  </ButtonItem>
                )}
                <ButtonItem
                  type="default"
                  icon={<ExportOutlined />}
                  azulMarino
                  onClick={() => this.exportarInsumos()}
                >
                  Exportar Insumos
                </ButtonItem>
            </HeaderActions>

             {this.props.permisoAgregarInsumo && (
                <ButtonItem
                  type="primary"
                  olivo
                  onClick={() => this.agregarInsumo()}
                  style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
                >
                  Agregar Insumo
                </ButtonItem>
              )}
              </div>
          }
        />
        <TableItemDinamico
          ref={(ref) => this.tableRef = ref}
          onRef={(ref) => this.tableRef = ref}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          anadirValorFiltro={valorActual}
          onFetchData={this.consultarInsumos.bind(this)}
          size="small"
          dataSource={this.state.todasInsumos}
          columns={columns}
          pagination={false}
          onRow={(record) => ({
            onDoubleClick: () => this.editarInsumo(record._id),
          })}
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
          camposBusqueda={{
            storageKey: "insumosCamposBusqueda_" + this.props.empresaId,
            fijo: { campo: "clave", etiqueta: "Clave" },
            opcionales: [
              { campo: "descripcion", etiqueta: "Descripcion" },
              { campo: "codigoBarras", etiqueta: "Cod. barras" },
              { campo: "codigo", etiqueta: "Codigo" },
            ],
          }}
          filterStorageKey={"insumosFiltrosTabla" + this.props.empresaId}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={valorDefault}
          valorTextoDefault={""}
        />
        <CambiarFamilia
          visible={this.state.idCambiarFamilia !== null}
          id={this.state.idCambiarFamilia}
          cerrarCambiarFamilia={this.cerrarCambiarFamilia.bind(this)}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
        <ModalCodigoDeBarras
          visible={this.state.modalImprimirCodigoDeBarras}
          insumoId={this.state.modalImprimirCodigoDeBarrasId}
          cerrarModalCodigoDeBarras={this.cerrarModalCodigoDeBarras.bind(this)}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
        <ModalEtiquetaLoteInsumo
          visible={this.state.modalEtiquetaLoteInsumo}
          insumoId={this.state.modalEtiquetaLoteInsumoId}
          cerrarModal={this.cerrarEtiquetaLoteInsumo.bind(this)}
        />
        <ModalVerFormas
          visible={this.state.modalVerFormas}
          insumoId={this.state.modalVerFormasId}
          cerrarModalVerFormas={this.cerrarModalVerFormas.bind(this)}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    taxidermia: state.empresa.taxidermia,
    filtrosAvanzadosInsumos: state.empresa.filtrosAvanzadosInsumos,
    decimalesEmpresa: state.empresa.decimalesEmpresa,
    permisoAgregarInsumo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ccd1cf30e81b54183cf75")?.activado,
    permisoEditarInsumo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ccd41f30e81b54183cf76")?.activado,
    permisoImportarInsumo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "67509111798d4e004368723e")?.activado,
    permisoImportarEquivalencias: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6ab2e19f28e43beedf1d5a9a")?.activado,
    permisoAccesoFiltrosAvanzados: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a0c8e5895cdbbe290cdf782")?.activado,
    noMostrarInsumoCompra: state.user.tipo !== 0 && !!state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a3b49bc65cffab7b63d1266")?.activado,
    noMostrarInsumoVenta: state.user.tipo !== 0 && !!state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a3b49eb65cffab7b63d1267")?.activado,
    noMostrarInsumoAmbos: state.user.tipo !== 0 && !!state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a3b4a2f65cffab7b63d126a")?.activado,
    noMostrarInsumoNinguno: state.user.tipo !== 0 && !!state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a3b4a8c615b3ccfbbea4665")?.activado,
    noMostrarFiltroTodos: state.user.tipo !== 0 && !!state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a3b4abedd1b71df05ea4ea5")?.activado,
    noMostrarDeshabilitados: state.user.tipo !== 0 && !!state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a3b4ad4dd1b71df05ea4ea6")?.activado,
  };
};

export default connect(mapStateToProps)(Insumos);
